module.exports = __webpack_public_path__ + "static/img/00.8e11bd1a.png";